import { useEffect, useMemo, useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import { fetchAllByIds } from "@/lib/supabasePaging";
import { latestCycleByCase, type ReminderCycle } from "@/lib/reminderProgress";

const CYCLE_SELECT =
  "id, case_id, status, current_step, next_step, next_reminder_at, last_client_response_at, last_error, stopped_reason, paused_at, completed_at, unsubscribed_at, rejected_at, updated_at, created_at";
const REFRESH_MS = 60_000;

/** Dernier cycle de relance devis de chaque dossier affiché (rafraîchi chaque minute et à chaque changement de liste). */
export function useReminderCycles(caseIds: string[]): Map<string, ReminderCycle> {
  const [cycles, setCycles] = useState<ReminderCycle[]>([]);
  const key = useMemo(() => [...caseIds].sort().join(","), [caseIds]);

  useEffect(() => {
    const ids = key ? key.split(",") : [];
    if (!ids.length) {
      setCycles([]);
      return;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const rows = await fetchAllByIds<ReminderCycle>(ids, (chunk, from, to) =>
          supabase
            .from("quote_reminder_cycles")
            .select(CYCLE_SELECT)
            .in("case_id", chunk)
            .order("created_at", { ascending: true })
            .order("id", { ascending: true })
            .range(from, to)
        );
        if (!cancelled) setCycles(rows);
      } catch (error) {
        console.warn("[relances] chargement des cycles impossible", error);
      }
    };
    load();
    const timer = window.setInterval(load, REFRESH_MS);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, [key]);

  return useMemo(() => latestCycleByCase(cycles), [cycles]);
}
